import type { TypedClient } from '@platform/openapi';
import type { StockLevel } from './inventory.ts';

export const MAX_IDS_PER_REQUEST = 100;

export const chunksOf = <Item>(items: readonly Item[], size: number): Item[][] =>
  Array.from({ length: Math.ceil(items.length / size) }, (_, index) =>
    items.slice(index * size, (index + 1) * size),
  );

export const fetchStockLevels = async (
  api: TypedClient,
  variantIds: readonly string[],
): Promise<{ readonly items: readonly StockLevel[] }> => {
  const chunks = chunksOf([...new Set(variantIds)], MAX_IDS_PER_REQUEST);
  const answers = await Promise.all(
    chunks.map((chunk) => api.get('/admin/inventory', { query: { variant_id: chunk } })),
  );
  return { items: answers.flatMap((answer) => answer.items) };
};
